import { Unify_Three } from "./unify-three/Unify";

const unify = new Unify_Three({
  debugMode: true, // enable verbose engine console logging
  editMode: false, // built-in camera controls, object inspection, transform /helper widgets etc. [not yet implemented]
  postProcessorEnabled: true // enable post processing via EffectComposer, false uses standard renderer
});

import * as Resources from "./project/Resources";
const resources = Resources;

/* Register Modules -------------------------------------------------- //*
 * It is recommended to pass a unify ref to each module,
 * see documentation @ https://gitlab.com/buck-co/protojam/unify-three/-/blob/master/README.md
 */

unify.addModule(require("./project/Settings"));
unify.addModule(require("./project/Environment"));
unify.addModule(require("./project/Terrain"));
unify.addModule(require("./project/DrivingController"));
unify.addModule(require("./project/EnemyController"));
unify.addModule(require("./project/TuneNuggets"));
unify.addModule(require("./project/Sounds"));
unify.addModule(require("./project/PositionalSound"));
unify.addModule(require("./project/GameLogic"));
unify.addModule(require("./project/PostEffects"));
unify.addModule(require("./project/UI")); // <-- ui is calling unify.start()

/* << Engine Awake >>
 * ---------------------------------------------------------------------- //*
 */
unify.awake();
//unify.start();
/* << Engine Start >>
 * ---------------------------------------------------------------------- //*
 */
// main.unify.start(); <-- this is being called within UI.js on html start button press

/* ---------------------------------------------------------------------- //*
 * [ << Unify - Module Function Callback Execution Order >> ]
 * ---------------------------------------------------------------------- //*
 *
 * [<---------- unify.awake() is called ---------->]
 * - module.load { ref: loadManager } <-- called once, passes reference to loadManager
 * - module.loadProgress { number: loadProgress } <-- called per item loaded, passes % progress value [0-100]
 * - module.awake { } <-- called once
 * - module.earlyUpdate { } <-- begins calling once per frame after awake
 *
 * [<------ Loading Manager Complete ----->] <-- start callbacks are now allowed
 *
 * [<---------- unify.start() ---------->]
 * - module.start { } <-- called once
 * - module.update { } <-- begins calling once per frame after start
 */
